export default __webpack_public_path__ + "static/media/file-gray.88bb914b.svg";